// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3RC3x","errors":"Errors_errors__3XxQG"};